import _ from 'lodash';

import {paletteColors, PaletteColorsEnum} from '../../models/api/paletteModel';

const paletteColorsWithoutBlue = _(paletteColors).without(PaletteColorsEnum.BLUE).value();

export function colorForTeammateId(src: number) {
  const finalColor = paletteColors[src % paletteColors.length];

  // Exclude blue from teammate avatars because it blends in with the blue
  // highlight of selected P2 items.
  if (finalColor === PaletteColorsEnum.BLUE) {
    return paletteColorsWithoutBlue[src % paletteColorsWithoutBlue.length];
  }

  return finalColor;
}
